import Component from "./Component";

export default class Select extends Component {
	constructor(element, data) {
		super(element, data);

		this.$input = this.el.querySelector(".select-input");
		this.$options = this.$input.querySelectorAll("option");
		this.$currentValue = this.el.querySelector(".select-current-value");
		this.$placeholders = this.el.querySelector(".select-placeholders");
		this.handleChange = this.handleChange.bind(this);

		this.setPlaceholders();
		this.setSelectedLabel();
	}

	get events() {
		return {
			["change .select-input"]: "handleChange"
		};
	}

	setPlaceholders() {
		this.$options.forEach($option => {
			const $text = document.createElement("span");
			$text.innerText = $option.innerText.trim();
			const $br = document.createElement("br");
			this.$placeholders.appendChild($text);
			this.$placeholders.appendChild($br);
		});
	}

	handleChange() {
		this.setSelectedLabel();
	}

	setSelectedLabel() {
		const selectedIndex = this.$input.selectedIndex;
		const text = this.$options[selectedIndex]
			? this.$options[selectedIndex].innerText.trim()
			: "";
		this.$currentValue.innerText = text || " ";
	}
}
